<template>
  <page :manualInit="postingState.init" :manualErr="postingState.initErr" @reload="doInit">
    <div v-if="renderAppType">
      <v-subheader>
        {{labels.appID}}
      </v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['motorClaimPost'])">
            <v-card :class="isMatchRoute('motorClaimPosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'motorClaimPosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MOTOR}}</v-icon>
                <span>Motor</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelClaimPost'])">
            <v-card :class="isMatchRoute('travelClaimPosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'travelClaimPosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['fireClaimPost'])">
            <v-card :class="isMatchRoute('fireClaimPosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'fireClaimPosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <!-- <v-flex lg2 md3 xs6 v-if="checkAccess(['paClaimPost'])">
            <v-card :class="isMatchRoute('paClaimPosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'paClaimPosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PA}}</v-icon>
                <span>Personal Accident</span>
              </v-layout>
            </v-card>
          </v-flex> -->
          <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoClaimPost'])">
            <v-card :class="isMatchRoute('cargoClaimPosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'cargoClaimPosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.CARGO}}</v-icon>
                <span>Cargo</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidClaimPost'])">
            <v-card :class="isMatchRoute('maidClaimPosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'maidClaimPosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['packageClaimPost'])">
            <v-card :class="isMatchRoute('packageClaimPosting') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'packageClaimPosting' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PACKAGE}}</v-icon>
                <span>Package</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div>
      <transition name="slide-x-transition" mode="out-in">
        <router-view ></router-view>
      </transition>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import routeMixin from '@/mixins/route'
import { appIcon } from '@/const/underwriting'

export default {
  data() {
    return {
      labels: {
        appID: 'Application Type'
      }
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.name === 'claimPosting') {
        this.doInit()
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    postingState() {
      return this.$store.state.claims.posting
    },
    renderAppType() {
      if (this.isMatchRouteExact('claimPosting') ||
        this.isMatchRouteExact('motorClaimPosting') ||
        this.isMatchRouteExact('travelClaimPosting') ||
        this.isMatchRouteExact('fireClaimPosting') ||
        this.isMatchRouteExact('maidClaimPosting') ||
        this.isMatchRouteExact('cargoClaimPosting') ||
        this.isMatchRouteExact('packageClaimPosting')) {
        return true
      } else {
        return false
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('claimPostingInit')
    }
  },
  mounted() {
    this.doInit()
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "../../assets/scss/agency.scss";
</style>
